export function inputSelectStyle() {
  const Selects = document.querySelectorAll('.js-form-select');
  if(Selects.length) {
    for (let i = 0; i < Selects.length; i++) {
      const el = Selects[i];
      const view = el.querySelector('.js-select-view');
      const hidden = el.querySelector('.js-select-hidden');

      hidden.addEventListener('change', function(e) {
        const index = hidden.selectedIndex;
        const selectedOption = hidden.options[index];
        view.textContent = selectedOption.innerHTML
      });
      if(hidden && hidden.value !== '') {
        view.textContent = hidden.value;
      }
    }
  }
}